// components/CartSkeleton.js
import React from "react";
import {
  HeaderShimmer,
  TabShimmer,
  RestaurantShimmer,
  AddressShimmer,
  CartItemsShimmer,
  OrderSummaryShimmer
} from "./CartShimmer";

const CartSkeleton = () => {
  return (
    <div className="container mx-auto px-4 max-w-6xl">
      <HeaderShimmer />
      <TabShimmer />
      <RestaurantShimmer />
      <AddressShimmer />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <CartItemsShimmer />
        </div>
        <div className="lg:col-span-1">
          <OrderSummaryShimmer />
        </div>
      </div>
    </div>
  );
};

export default CartSkeleton;